import type { Money } from '@klear/money'
import {
  PAYMENT_LINE_ITEM_SOURCE_ITEM,
  PAYMENT_LINE_ITEM_SOURCE_ORDER_EVENT,
  PAYMENT_LINE_ITEM_TYPE_PURCHASE,
  type PAYMENT_LINE_ITEM_SOURCES,
  type PaymentLineItemType
} from '@klear/payment/constants'
import type { PaymentItemWire } from '@klear/payment/item.wire'

export type PaymentLineItemSource = (typeof PAYMENT_LINE_ITEM_SOURCES)[number]

export type PaymentLineItem = {
  source: PaymentLineItemSource
  label: string
  amount: Money
  orderEventId?: number
  orderId?: number
  parentEventId?: number
  effectiveDate?: string
  eventAmount?: Money
  unresolved?: boolean
  itemType?: PaymentLineItemType
  note?: string
}

export function isEventLine(item: PaymentLineItem): boolean {
  return item.source === PAYMENT_LINE_ITEM_SOURCE_ORDER_EVENT
}

export function isItemLine(item: PaymentLineItem): boolean {
  return item.source === PAYMENT_LINE_ITEM_SOURCE_ITEM
}

export function paymentItemWireFromLine(item: PaymentLineItem): PaymentItemWire {
  return {
    type: item.itemType ?? PAYMENT_LINE_ITEM_TYPE_PURCHASE,
    amount: item.amount.toJSON(),
    note: item.note || undefined
  }
}

export function isNavigableLine(item: PaymentLineItem): boolean {
  return (
    isEventLine(item) &&
    item.unresolved !== true &&
    item.orderEventId != null &&
    item.orderEventId > 0 &&
    item.orderId != null &&
    item.orderId > 0
  )
}

export function linkedEventIdsFrom(lineItems: PaymentLineItem[]): number[] {
  return lineItems
    .filter((item) => isEventLine(item) && item.unresolved !== true)
    .map((item) => item.orderEventId)
    .filter((id): id is number => id != null && id > 0)
}
